module.exports = __webpack_public_path__ + "img/logo-powerline.d9c51bc0.png";